import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiUrls } from "constants/apiUrls";
import { UserResponse } from "pages/Settings/types";
import { ChangePasswordProps } from "slice/jobs/types";
import { baseQueryWithReAuth } from "utils/baseQueryWithReAuth";
import { getResolvedUrl } from "utils/getResolvedUrl";
import { Common, Country, Currency } from "./types";

export const initialState: Common = {
    socialPlatforms: [],
};

export const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        setSocialPlatforms(state, { payload }: PayloadAction<Common>) {
            state.socialPlatforms = payload.socialPlatforms;
        },
    },
});

export const commonApiSlice = createApi({
    reducerPath: "commonApi",
    baseQuery: baseQueryWithReAuth,
    endpoints(builder) {
        return {
            getSocialPlatforms: builder.query({
                query: () => ({
                    url: apiUrls.socialPlatforms,
                }),
            }),
            getCountries: builder.query<Country[], any>({
                query: () => ({
                    url: apiUrls.countries,
                }),
            }),
            getCities: builder.query({
                query: () => ({
                    url: apiUrls.cities,
                }),
            }),
            getLanguages: builder.query({
                query: () => ({
                    url: apiUrls.languages,
                }),
            }),
            getCurrencies: builder.query<Currency[], any>({
                query: () => ({
                    url: apiUrls.currencies,
                }),
            }),
            getAccountDetails: builder.query<UserResponse, any>({
                query: (user_id) => ({
                    url: getResolvedUrl(apiUrls.accountDetails, { user_id }),
                }),
            }),
            deleteUserAccount: builder.mutation<void, string>({
                query: (user_id) => ({
                    url: getResolvedUrl(apiUrls.deleteAccount, { user_id }),
                    method: "DELETE",
                }),
            }),
            changePassword: builder.mutation<any, ChangePasswordProps>({
                query: ({ user_id, ...props }) => ({
                    url: getResolvedUrl(apiUrls.changePassword, { user_id }),
                    method: "PUT",
                    body: props,
                }),
            }),
        };
    },
});

export const {
    useGetSocialPlatformsQuery,
    useGetCitiesQuery,
    useGetCountriesQuery,
    useGetLanguagesQuery,
    useGetCurrenciesQuery,
    useGetAccountDetailsQuery,
    useDeleteUserAccountMutation,
    useChangePasswordMutation,
} = commonApiSlice;
export const { setSocialPlatforms } = commonSlice.actions;
export default commonSlice.reducer;
